import React from 'react';
import { READING_LEVELS, type ReadingLevel } from '@/lib/story/reading-level';
import { cn } from '@/lib/utils';

interface ReadingLevelPickerProps {
  value: ReadingLevel;
  onChange: (level: ReadingLevel) => void;
}

/** Two-way choice of how much text each story page carries (picture book vs story time). */
export function ReadingLevelPicker({ value, onChange }: ReadingLevelPickerProps) {
  const ids = Object.keys(READING_LEVELS) as ReadingLevel[];
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
      {ids.map((id) => {
        const level = READING_LEVELS[id];
        const selected = value === id;
        return (
          <button
            key={id}
            type="button"
            aria-pressed={selected}
            onClick={() => onChange(id)}
            className={cn(
              'rounded-lg border-2 p-3 text-left transition-colors',
              selected ? 'border-purple-600 bg-purple-50' : 'border-gray-200 hover:border-purple-300'
            )}
          >
            <span className="block font-semibold text-gray-900">
              {level.label} <span className="font-normal text-gray-600">({level.ages})</span>
            </span>
            <span className="mt-1 block text-sm text-gray-600">{level.blurb}</span>
          </button>
        );
      })}
    </div>
  );
}
